import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Bar, Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
);

function Reports() {
  const [totalMonthlyUsers, setTotalMonthlyUsers] = useState(0);
  const [totalHourlyUsers, setTotalHourlyUsers] = useState(0);
  const [totalDayUsers, setTotalDayUsers] = useState(0);
  const [currentDateTime, setCurrentDateTime] = useState(new Date());

  useEffect(() => {
    // Fetch total monthly users
    const fetchTotalMonthlyUsers = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_API_URL}/getUser/api/totalMonthlyUser`);
        setTotalMonthlyUsers(response.data.total);
      } catch (error) {
        console.error("❌ Error fetching total monthly users:", error);
      }
      const interval = setInterval(() => {
        setCurrentDateTime(new Date());
      }, 1000); // update every second

      return () => clearInterval(interval); // cleanup
    };

    fetchTotalMonthlyUsers();

    // Fetch total hourly users (assuming this is a separate endpoint)
    const fetchTotalHourlyUsers = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_API_URL}/getUser/api/totalHourlyUser`);
        // const response = await axios.get("http://localhost:5000/getUser/api/totalHourlyUser");
        setTotalHourlyUsers(response.data.total);  // Use the correct state setter
      } catch (error) {
        console.error("❌ Error fetching total hourly users:", error);
      }
    };

    fetchTotalHourlyUsers();

    // Fetch total hourly users (assuming this is a separate endpoint)
    const fetchTotalDayUsers = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_API_URL}/getUser/api/totalDayUser`);
        setTotalDayUsers(response.data.total);  // Use the correct state setter
      } catch (error) {
        console.error("❌ Error fetching total hourly users:", error);
      }
    };

    fetchTotalDayUsers();
  }, []);
  const labels = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
  ];

  const barData = {
    labels: labels,
    datasets: [
      {
        label: "Monthly Users",
        data: [65, 59, 80, 81, 56, 55, 40],
        backgroundColor: "rgba(75, 192, 192, 0.2)",
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
      },
    ],
  };

  const lineData = {
    labels: labels,
    datasets: [
      {
        label: "Hourly Users",
        data: [65, 59, 80, 81, 56, 55, 40],
        fill: false,
        borderColor: "rgb(75, 192, 192)",
        tension: 0.1,
      },
    ],
  };

  const options = {
    responsive: true,
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  return (
    <>
      <div className="reports container mt-1">
        <div className="d-flex justify-content-between align-items-center">
          <h1>Welcome Admin! Have a Good Day</h1>
          <div className="text-end">
            <h6>Date: {currentDateTime.toLocaleDateString()}</h6>
            <h6>Time: {currentDateTime.toLocaleTimeString()}</h6>
          </div>
        </div>
        <div className="row g-3 mt-4">
          <div className="col-lg-6 col-12">
            <div className="p-3 border shadow-sm rounded bg-white">
              <h2 className="text-center">Monthly User Data</h2>
              <Bar data={barData} options={options} />
            </div>
          </div>
          <div className="col-lg-6 col-12">
            <div className="p-3 border shadow-sm rounded bg-white">
              <h2 className="text-center">Hourly User Data</h2>
              <Line data={lineData} options={options} />
            </div>
          </div>
        </div>
        {/* number of users list */}
        <div className="userCount container mt-4 mb-3">
          <div className="row justify-content-between">
            <div className="col-lg-3 col-md-4 col-sm-6 d-flex justify-content-center">
              <Link to="/adminDashboard/monthlyParkingList" className="text-decoration-none">
                <div className="card monthly text-center p-3">
                  <h2>Total Monthly Users</h2>
                  <p>{totalMonthlyUsers}</p>
                </div>
              </Link>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 d-flex justify-content-center">
              <Link to="/adminDashboard/hourlyParkingList" className="text-decoration-none">
                <div className="card hourly text-center p-3">
                  <h2>Total Hourly Users</h2>
                  <p>{totalHourlyUsers}</p>
                </div>
              </Link>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 d-flex justify-content-center">
              <Link to="/adminDashboard/dayParkingList" className="text-decoration-none">
                <div className="card daily text-center p-3">
                  <h2>Total Daily Users</h2>
                  <p>{totalDayUsers}</p>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Reports;
